module.exports = __webpack_public_path__ + "img/BIsBR.40a6deac.png";